export default "__VITE_ASSET__2480f8d8__"